import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const SliderNav = styled.nav`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[4]};
  width: 100%;
`;

export const SliderArrow = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
  cursor: pointer;
  background-color: ${theme.colors.darkBlues[5]};
  border-radius: 100%;
  transition: all 0.1s ease-out;

  i {
    font-size: ${theme.fontSizes[3]};
  }

  &:hover {
    background-color: ${theme.colors.blues[100]};
    color: ${theme.colors.white};
  }
`;
